/**
 * Utility functions for managing user_accounts documents
 */

import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebaseConfig";

/**
 * Creates a user_accounts document if it doesn't already exist
 * @param {string} userId - The user's UID
 * @param {string} email - The user's email
 * @param {string} signUpMethod - The signup method ('email', 'google', 'apple')
 * @returns {Promise<boolean>} - Returns true if document was created, false if it already existed
 */
export const createUserAccountIfNotExists = async (
  userId,
  email,
  signUpMethod,
) => {
  try {
    if (!userId || !email || !signUpMethod) {
      throw new Error(
        "Missing required parameters: userId, email, and signUpMethod are required",
      );
    }

    const userAccountRef = doc(db, "user_accounts", userId);
    const userAccountDoc = await getDoc(userAccountRef);

    if (!userAccountDoc.exists()) {
      await setDoc(userAccountRef, {
        uid: userId,
        email: email,
        sign_up_method: signUpMethod,
        created_at: serverTimestamp(),
      });
      return true;
    }

    return false;
  } catch (error) {
    console.error("Error creating user_accounts document:", error);
    throw error;
  }
};

